var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 d-flex align-items-center h-100 p-5"},[_c('div',{staticClass:"dot-opacity-loader"},[_c('span'),_c('span'),_c('span')])])
}]

export { render, staticRenderFns }